import { Component, Prop } from 'vue-property-decorator'
import { KhAnimationProps, KhText, Nullable } from '@internal-libraries/kheops-ui-lib'
import { DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT } from '../../const'
import { DEFAULT_HEIGHT_CONTAINER_SMALL } from '../../../../const'
import ScreenResolutionHelper from '../../../../../../system/vue/Classes/ScreenResolutionHelper'
import { ClvrScreenControlHeadersLabelsEnum } from '../../enum'
import ClvrScreenControlDataCell from '../ClvrScreenControlDataCell'
import ResourceType from '../../../../../../dPbloc/vue/Classes/ClvrResourceType'

@Component({
    components: {
        KhText,
    },
})
export default class ClvrScreenControlInterventionMaterialCell extends ClvrScreenControlDataCell {
    @Prop({ type: String, default: '' })
    public intervention!: string

    @Prop({ type: Array, default: () => [] })
    public materialList!: ResourceType[]

    @Prop({ type: String, default: '' })
    public materialToProvide!: string

    @Prop({ type: String, default: '' })
    public remarks!: string

    public get animationIntervention(): Nullable<KhAnimationProps> {
        return !this.printMode
            ? {
                  ...DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT,
                  text: this.intervention,
                  containerHeight: ScreenResolutionHelper.getSizeFor4KResolution(DEFAULT_HEIGHT_CONTAINER_SMALL),
              }
            : null
    }

    public get interventionMaterialAndRemark(): string {
        return [
            this.getDataTypeVisibility(ClvrScreenControlHeadersLabelsEnum.INTERVENTION_AND_REMARKS) ? this.remarks : '',
            this.getDataTypeVisibility(ClvrScreenControlHeadersLabelsEnum.INTERVENTION_AND_MATERIAL_TO_PROVIDE)
                ? this.materialToProvide
                : '',
            this.getDataTypeVisibility(ClvrScreenControlHeadersLabelsEnum.INTERVENTION_AND_MATERIAL_LIST)
                ? this.materialList?.map(material => material.label ?? '').join(', ')
                : '',
        ]
            .filter(item => !!item)
            .join(', ')
    }

    public get animationMaterial(): Nullable<KhAnimationProps> {
        return !this.printMode
            ? {
                  ...DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT,
                  text: this.interventionMaterialAndRemark,
                  containerHeight: ScreenResolutionHelper.getSizeFor4KResolution(DEFAULT_HEIGHT_CONTAINER_SMALL),
              }
            : null
    }
}
